'use strict';

/**
 * @name ProfileSettingsController
 * @param {*}  
 * @param {*} HoogyService 
 * @param {*} NotificationService 
 * @param {*} Angularytics 
 */
function ProfileSettingsController($auth, HoogyService, PeopleService, NotificationService, UIService, StateService, ActionCreator, Angularytics) {

    var vm = this;

    /**
     * @name $onInit 
     */
    this.$onInit = function () {        
        this.model = PeopleService.getMe();
        this.screen = UIService.getSettingsScreen({component: 'profile:settings', active: 'profile'});
        StateService.dispatch(ActionCreator.addScreen(this.screen));
        this.unsubscribe = this.subscribe();
        this.init();
    };

    /**
     * @name subscribe - Subscribe to PeopleService
     */
    this.subscribe = function () {
        return typeof this.unsubscribe === 'function' ? false: StateService.subscribe(function () {
            vm.model = PeopleService.getMe();
            vm.model.notifications = NotificationService.getModel();                
            vm.screen = UIService.getSettingsScreen(vm.screen);
        });
    };
    /**
     * @name init - initialization 
     * @navigation
     * @return {Object} 
     */
    this.init = function () {
        Angularytics.trackEvent('Settings Profile', +1);
    };


    /**
     * @deprecated - Move all save settings into dependent components. 
     * @todo all settings will be sent to server using this function
     * @todo use HoogyService::setSettings([options], next);
     */
    this.save = function (form) {
        var settings = {
            action: form.$name,
            data: this.model.local
        };
        if (!form || !form.$valid || form.$invalid) {
            throw 'Profile Settings Requires a Valid Form';
        }
        return HoogyService.updateSettings(settings)
            .then(this._settingsRequestCallback)
            .catch(this._handleException);
    };

    /**
     * @name reset - resetting the form 
     * @param {FormController} form
     */
    this.reset = function (form) {
        if (!form || typeof form.$setPristine !== 'function') {
            throw 'Reset Requires a Form.';
        }
        form.$setPristine();
        Angularytics.trackEvent('Settings Reset', +1);
    };


    /**
     * @name link - Link third-party provider
     * @todo replace $auth with AutService::link + AuthService.unlink 
     */
    this.link = function (prov) {
        var provider = prov; //to be used outside
        this.screen.link = true;
        $auth.link(provider)
            .then(function (response) {
                vm.initProfile();
                return response;
            })
            .then(this._settingsRequestCallback)
            .catch(this._handleException);
        Angularytics.trackEvent(['Profile Link - Initialized - ', provider].join(''), +1);
    };

    /**
     * @name unlink - Unlink third-party provider.
     * @todo replace $auth with AutService::link + AuthService.unlink 
     */
    this.unlink = function (prov) {
        var provider = prov; //to be used outside
        this.screen.unlink = true;
                 
        $auth.unlink(provider)
            .then(function (response) {
                vm.initProfile();
                return response;
            })
            .then(this._settingsRequestCallback)
            .catch(this._handleException);
        Angularytics.trackEvent('Profile Unlink - Initialized', +1);
    };
   
    /**
     * @param {Object<Error>} error
     * @name _handleException - Handling Exception of Profile Request.
     * @return {Promise<Error>}
     */
    this._handleException = function (error) {
        vm.enableSave = false;
        vm.screen.waiting = false;
        var notice = NotificationService.formatSettingsFailureMessage(error);
        if (vm.screen.unlink) {
            vm.screen.unlink = false;
            notice = NotificationService.formatUnlinkSettingsFailureMessage(error);
        }
        if (vm.screen.link) {
            vm.screen.link = false;
            notice = NotificationService.formatLinkSettingsFailureMessage(error);
        }
        NotificationService.report(notice);                  
        Angularytics.trackEvent('Settings Profile Update Exception ', notice.message);
        return error;
    };


    /**
     * @name _settingsRequestCallback - Private callback used by final promise
     * @param  {Object} response - Response for requests  
     * @return {Promise} 
     */
    this._settingsRequestCallback = function (response) {
        vm.screen.waiting = false;
        var notice = NotificationService.formatSettingsSuccessMessage(response);
        if (vm.screen.unlink) {
            vm.screen.unlink = false;
            notice = NotificationService.formatUnlinkSettingsSuccessMessage(response);
        }
        if (vm.screen.link) {
            vm.screen.link = false;
            notice = NotificationService.formatLinkSettingsSuccessMessage(response);
        }
        NotificationService.notify(notice);
        Angularytics.trackEvent('Settings Profile Update Success', notice.message);
        return response;
    };

    /**
     * @name $onDestroy - cleans objects when components dies.
     */
    this.$onDestroy = function () {
        if (typeof this.unsubscribe === 'function') {
            this.unsubscribe();
        }
        this.unsubscribe = null;
    };
}

ProfileSettingsController.$inject = ['$auth', 'HoogyService', 'PeopleService', 'NotificationService', 'UIService', 'StateService', 'ActionCreator', 'Angularytics'];
angular.module('hoogy').component('profileSettings', {
    controllerAs: 'vm',
    templateUrl: 'js/settings/view/profile.html',
    controller: ProfileSettingsController
});